import React from "react";
import { Reveal } from "../shared/Reveal";

export default function Letter() {
  return (
    <section id="letter" className="letter">
      <div className="wrap letterwrap">
        <Reveal className="eyebrow" tag="div" style={{ textAlign: "left" }}>KNOWLEDGE BEFORE INVESTMENT</Reveal>
        <Reveal className="rule" tag="div" />
        <Reveal className="dear" tag="div">Dear Sirs,</Reveal>
        <Reveal className="lead2" tag="div">
          Solar panels generate electricity. Battery storage stores it. But neither identifies where your building is <span className="g">already wasting energy.</span>
        </Reveal>
        <div className="body">
          <Reveal tag="p">Before investing in renewable technologies, hidden operational inefficiencies could already be costing your organisation <b>up to a further 30% in unnecessary energy consumption.</b> That is why every energy journey should begin with intelligence.</Reveal>
          <Reveal tag="p">Our platform <b>identifies hidden waste</b>, optimises the way your building consumes electricity, gas and water, and then continues to <b>manage energy performance in real time.</b></Reveal>
          <Reveal tag="p"><b>The result?</b> Less waste. Greater efficiency. Better-performing solar panels. Better-performing battery storage. Better business decisions.</Reveal>
          <Reveal tag="p">We would welcome the opportunity to begin with a <b>no-cost Gap Analysis</b> — so you can see exactly what your building is telling you, before a single penny is invested.</Reveal>
        </div>
        <Reveal className="close" tag="div">Knowledge <span className="g">Before</span> Investment.</Reveal>
        <Reveal className="sign" tag="div">
          <div className="ys">Yours sincerely,</div>
          <div className="nm">Michael</div>
          <div className="rl">Energy Vault Group</div>
        </Reveal>
      </div>
    </section>
  );
}
